import React from "react";

// https://github.com/streamich/react-use/blob/master/docs/useEnsuredForwardedRef.md
function useEnsuredForwardedRef<T>(
  forwardedRef: React.RefObject<T> | ((instance: T | null) => void) | null,
) {
  // final ref that will share value with forwardedRef. this is the one we will attach to components
  const ensuredRef = React.useRef<T>(
    forwardedRef && "current" in forwardedRef ? forwardedRef.current : null,
  );
  React.useLayoutEffect(() => {
    // after every render - try to share current ref value with forwarded ref
    if (!forwardedRef) return;
    if (typeof forwardedRef === "function") {
      forwardedRef(ensuredRef.current);
    } else {
      (forwardedRef as React.MutableRefObject<T>).current = ensuredRef.current as T;
    }
  });

  return ensuredRef;
}

export default useEnsuredForwardedRef;
